import script from "./researchCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./researchCenter.vue?vue&type=script&setup=true&lang=js"

import "./researchCenter.vue?vue&type=style&index=0&id=c802713c&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c802713c"]])

export default __exports__